import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=a86191b4&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a86191b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a86191b4')) {
      api.createRecord('a86191b4', component.options)
    } else {
      api.reload('a86191b4', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=a86191b4&scoped=true&", function () {
      api.rerender('a86191b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2RMAjWYr1z197/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports